module.exports = __webpack_public_path__ + "img/DE04044.defc3cb9.png";